import actionTypes from '../actionTypes';

export function getAnomalyDetectionData(payload) {
	return {
		type: actionTypes.GET_ANOMALY_DETECTION_DATA,
		payload,
	};
}

export function getAnomalyDetectionDataSuccess(payload) {
	return {
		type: actionTypes.GET_ANOMALY_DETECTION_DATA_SUCCESS,
		payload,
	};
}

export function getAnomalyDetectionDataFailure(payload) {
	return {
		type: actionTypes.GET_ANOMALY_DETECTION_DATA_FAILURE,
		payload,
	};
}

export function updateTableRowsAndColumns(payload) {
	return {
		type: actionTypes.UPDATE_TABLE_ROWS_AND_COLUMNS,
		payload,
	};
}

export function getAnomaliesSalesMetrics(payload) {
	return {
		type: actionTypes.GET_ANOMALIES_SALES_METRICS,
		payload,
	};
}

export function getAnomaliesSalesMetricsSuccess(payload) {
	return {
		type: actionTypes.GET_ANOMALIES_SALES_METRICS_SUCCESS,
		payload,
	};
}

export function getAnomaliesSalesMetricsFailure(payload) {
	return {
		type: actionTypes.GET_ANOMALIES_SALES_METRICS_FAILURE,
		payload,
	};
}

export function resetADTableRows() {
	return {
		type: actionTypes.RESET_AD_TABLE_ROWS
	}
}